import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation, MutationResendVerificationCodeArgs } from 'graphql/generated/graphqlTypes';
import { RESEND_VERIFICATION_CODE } from 'graphql/mutations';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';
import { BaseHookProps } from '../shared/types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const RESEND_VERIFICATION_CODE_TYPED: TypedDocumentNode<
  Pick<Mutation, 'resendVerificationCode'>,
  MutationResendVerificationCodeArgs
> = RESEND_VERIFICATION_CODE;

const useResendVerificationCode = ({ handleFetchError }: BaseHookProps) => {
  const [resendVerificationCodeMutation, { loading }] = useMutation(RESEND_VERIFICATION_CODE_TYPED, {
    onError: () => {
      handleFetchError('Error while resending verification code');
    }
  });

  const resendVerificationCode = async (email: string) => {
    await ignoreHandledMutationError(
      resendVerificationCodeMutation({
        variables: {
          email
        }
      })
    );
  };

  return {
    loading,
    resendVerificationCode
  };
};

export default useResendVerificationCode;
